
import { async_command_dispatcher } from "@/api/client"

export class ToDoneCompanyCsvInvoicesCommand {

    company_ids: Array<number>
    user_id: number

    constructor(company_ids: Array<number>, user_id: number = undefined) {
        this.company_ids = company_ids
        this.user_id = user_id
    }

    async run() {
        let args = {company_ids: this.company_ids, user_id: this.user_id}

        let resOutput
        try {
            console.log("run ToDoneCompanyCsvInvoicesCommand", args)
            resOutput = await async_command_dispatcher.dispatch_with_result('csv.invoices.to.done', args, 1000)
        } catch (error) {
            console.error("Error setting CSV invoices to 'done'", error)
            resOutput = null
        }
        return resOutput
    }

}